import { gql } from '__generated__';

export default gql(`
  query GetTicketNumberSequencesForEvent($project_id: ID!, $event_id: ID!) {
    project(id: $project_id) {
      id
      event(id: $event_id) {
        id
        assigned_ticket_number_count
        locked_ticket_number_count
        missing_ticket_number_count
        assigning_ticket_numbers
        auto_assign_ticket_numbers
        ticket_numbers_published
        ticket_number_sequences {
          id
          title
          start_number
          prefix
          suffix
          example
          start_time
          corral_name
          capacity
          locked
          assigned_ticket_number_count
          locked_ticket_number_count
          deletable
          scanner {
            id
            title
          }
        }
      }
    }
  }
`);
